export enum UserRole {
  Client = "Client",
}
